import { ReactQuery } from '@codeleap/query'
import { useProfile } from './useProfile'
import { CompanyTheme } from '@/config'

export const useCompanyBranding = () => {
  const profile = useProfile()

  const query = ReactQuery.useQuery({
    queryKey: ['companyBranding', profile?.data?.tid],
    enabled: !!profile?.data?.id,
    queryFn: () => {

      return CompanyTheme.API.retrieve()
    },

  })

  const logo = query.data?.logo
  const companyName = profile.data.company_name || 'Connect'
  const companyDepartment = null // Placeholder for future use
  const companyLocation = null // Placeholder for future use

  return {
    logo,
    companyName,
    companyDepartment,
    companyLocation,
  }
}
